import * as React from "react";
import { toINR } from "../../../service/numberFormat";

export interface ILimitsLeftColProps {
	payIn?: string;
	clearCB?: string;
	notionalCash?: string;
	adHocMargin?: string;
	collateralValue?: string;
}

const LimitsLeftCol: React.FC<ILimitsLeftColProps> = (props) => {
	return (
		<div>
			<div className="row">
				<span className="label">Added (Pay In)</span>
				<span className="value">₹{toINR(props.payIn, 2)}</span>
			</div>
			<div className="thin_divider" />

			<div className="row">
				<span className="label">Clear Cash Balance</span>
				<span className="value">₹{toINR(props.clearCB, 2)}</span>
			</div>
			<div className="thin_divider" />

			{props.notionalCash && (
				<>
					<div className="row">
						<span className="label">Notional Cash</span>
						<span className="value">₹{toINR(props.notionalCash, 2)}</span>
					</div>
					<div className="thin_divider" />
				</>
			)}

			{props.adHocMargin && (
				<>
					<div className="row">
						<span className="label">Ad hoc Margin</span>
						<span className="value">₹{toINR(props.adHocMargin, 2)}</span>
					</div>
					<div className="thin_divider" />
				</>
			)}

			<div className="row">
				<span className="label">Collateral Value</span>
				<span className="value">₹{toINR(props.collateralValue, 2)}</span>
			</div>

			<div className="thin_divider" />
		</div>
	);
};

export default LimitsLeftCol;
